import SvgIcon from "components/general/svgIcon";
import styled from "styled-components";

const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 0 2rem 2rem 2rem;
  position: relative;
  z-index: 2;
  @media screen and (max-width: 992px) {
    padding: 1rem 2rem;
  }
  @media screen and (max-width: 768px) {
    padding: 0 2rem;
    margin-top: 2rem;
  }
`;
const StyledContainer = styled.div`
  max-width: 1280px;
  width: 100%;
  display: flex;
  align-items: flex-end;
  position: relative;
`;
const StyledBackground = styled.div`
  height: calc(100% - 4rem);
  background-color: var(--raised-background-color);
  border: 1px solid var(--background-color);
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-radius: 10px;
`;
const StyledImage = styled.img`
  position: absolute;
  right: 1rem;
  height: 100%;
  width: auto;
  bottom: 0;
  @media screen and (max-width: 992px) {
    display: none;
  }
`;
const StyledPlaystore = styled.img`
  height: 56px;
  width: auto;
`;
const StyledText = styled.div`
  width: 40%;
  padding: 8rem 2rem 2rem 2rem;
  position: relative;
  display: flex;
  flex-direction: column;
  > div {
    margin-bottom: 2rem;
  }
  @media screen and (max-width: 992px) {
    width: 100%;
  }
`;
const StyledFlex = styled.div`
  display: flex;
`;

const MobileRow = () => {
  return (
    <StyledWrapper>
      <StyledContainer>
        <StyledBackground />
        <StyledText>
          <StyledFlex>
            <a
              className="hero__button_row__icon"
              href="https://play.google.com/store/apps/details?id=dev.redact.app"
              target="_blank"
              rel="noreferrer"
            >
              <SvgIcon name="playstore" />
            </a>
            <a
              className="hero__button_row__icon"
              href="https://apps.apple.com/us/app/redact-privacy/id6449900531"
              target="_blank"
              rel="noreferrer"
            >
              <SvgIcon name="appstore" />
            </a>
          </StyledFlex>
          <h3 style={{ marginTop: 0 }}>
            Redact is now available in App Store and Google Play for your mobile device!
          </h3>
          <StyledFlex style={{ flexWrap: "wrap", gap: "1rem", marginTop: "1rem" }}>
            <a
              href="https://play.google.com/store/apps/details?id=dev.redact.app"
              target="_blank"
              rel="noreferrer"
            >
              <StyledPlaystore
                src="/images/playstore-download.png"
                alt="download playstore android"
                height={60}
                width={206}
              />
            </a>
            <a
              href="https://apps.apple.com/us/app/redact-privacy/id6449900531"
              target="_blank"
              rel="noreferrer"
            >
              <StyledPlaystore
                src="/images/appstore-download.svg"
                alt="download appstore ios"
                height={60}
                width={206}
              />
            </a>
          </StyledFlex>
        </StyledText>
        <StyledImage
          src="/images/mobile-android.png"
          alt="mobile preview"
          height={438}
          width={618}
        />
      </StyledContainer>
    </StyledWrapper>
  );
};

export default MobileRow;
